import React, { useCallback } from 'react';
import { formatTranslation } from 'intl';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { useIntl } from 'react-intl';
import { useDialog } from 'components/core/Dialog/common/DialogContext';
import { createUnlinkDocumentationDialog } from 'components/core/Dialog/common/dialogTemplates';
import { getIssueAttachmentDisplayName } from 'services/fileService/common/getFileDisplayName';
import { useGalleryContext } from '..';
import { ActionsType } from '../types';
import { ActionButton } from './actionButton';
import { IssueTranslationKeys } from 'intl/keys';

interface UnlinkDocumentationButtonProps {
  idx: number;
  actions: ActionsType;
  isMobile: boolean;
  onMenuClose?: () => void;
}

export const UnlinkDocumentationButton: React.FC<
  UnlinkDocumentationButtonProps
> = ({ idx, actions, isMobile, onMenuClose }) => {
  const intl = useIntl();
  const createDialog = useDialog();
  const { preview, useDisplayedFiles } = useGalleryContext();
  const [file] = useDisplayedFiles((files) => files[idx]);

  const label = formatTranslation(intl, IssueTranslationKeys.previewGalleryLinkedDocUnlinkLabel,);

  const handleUnlink = useCallback((): void => {
    if (preview) {
      return;
    }

    createUnlinkDocumentationDialog(
      createDialog,
      intl,
      getIssueAttachmentDisplayName(file)
    ).then(() => {
      actions.removeFile(idx);
      if (onMenuClose) {
        onMenuClose();
      }
    });
  }, [actions, createDialog, file, idx, intl, onMenuClose, preview]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleUnlink}
      disabled={preview}
      tooltipTitle={label}
      label={label}
      icon={<LinkOffIcon />}
    />
  );
};
